<template>
  <div class="home">
    <div v-if="!isLoaded" class="overlay"></div>
    <div class="container">
      <div class="logo">
        <img src="@/assets/images/top/logo.png" alt="NITE 独立行政法人 製品評価技術基盤機構">
      </div>
      <h1>
        <img src="@/assets/images/top/logo_keimaki.png" alt="身のまわりにかくれている微生物を探しだせ！ タッチ de びせいぶつ狩り">
      </h1>
      <p><img src="@/assets/images/top/txt_top.png" alt="ようこそ、「びせいぶつ」がみえる世界へ。きみが知っている身近な場所にいる「びせいぶつ」たちをみつけて、つかまえてみよう！「びせいぶつ」たちをタッチでたくさん“ほかく”して、きみだけのしょうごうを手にいれよう。"></p>
      <ul>
        <li>
          <router-link :to="{ name: 'stage-1' }">
            <img src="@/assets/images/top/button_stage1.png" alt="STAGE1">
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'stage-2' }">
            <img src="@/assets/images/top/button_stage2.png" alt="STAGE2">
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'stage-3' }">
            <img src="@/assets/images/top/button_stage3.png" alt="STAGE3">
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'stage-4' }">
            <img src="@/assets/images/top/button_stage4.png" alt="STAGE4">
          </router-link>
        </li>
      </ul>
      <GlobalNavigation />
      <OrientationAlert />
      <QRCode />
      <!-- <button @click="handleReset">リセット</button> -->
    </div>
  </div>
</template>

<script>
import GlobalNavigation from '@/components/GlobalNavigation.vue';
import OrientationAlert from '@/components/OrientationAlert.vue';
import QRCode from '@/components/QRCode.vue';
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';

export default {
  name: 'HomeView',
  components: {
    GlobalNavigation,
    OrientationAlert,
    QRCode,
  },

  setup() {
    const store = useStore();

    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove("a-fullscreen");

    const isLoaded = ref(false);

    onMounted(() => {
      setTimeout(() => {
        isLoaded.value = true;
      }, 1000);
    });

    // debug
    const handleReset = (e) => {
      // console.log('handleReset');
      store.commit('remove');
      store.commit('initialized');
      location.reload();
    }

    return {
      handleReset,
      isLoaded,
    }
  },
}
</script>

<style scoped lang="scss">
.home {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  z-index: 1;
  // padding: 5%;
  background-image: url(~@/assets/images/top/bg_top.png);
  background-size: cover;
}
.container {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  z-index: 1;
  padding: 5%;
  background-image: url(~@/assets/images/top/background_biseibutsu.png);
  background-size: cover;
}

.logo {
  max-width: 30%;
  width: 10vh;
  width: 10dvh;
  float: right;
  margin-top: -3%;
  margin-right: -3%;
}
h1 {
  clear: both;
  max-width: 100%;
  width: 45vh;
  width: 45dvh;
  margin: 0 auto;
  @media (max-width: 375px) {
    img {
      display: inline-block;
      margin-top: -5%;
    }
  }
}
p {
  max-width: 100%;
  width: 45vh;
  width: 45dvh;
  margin: 0 auto;
}
ul {
  max-width: 100%;
  width: 45vh;
  width: 45dvh;
  margin: 2vh auto 0;
  margin: 2dvh auto 0;
  display: flex;
  flex: 2;
  flex-wrap: wrap;
  li {
    width: calc(50%);
    // height: 100px;
    a {
      display: block;
      height: 100%;
      width: 100%;
    }
  }
  li:nth-child(odd) {
    padding: 1vw 2vw 1vw 0;
  }
  li:nth-child(even) {
    padding: 1vw 0 1vw 2vw;
  }
}
.overlay {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(~@/assets/images/top/bg_top.png);
  background-size: cover;
  opacity: 1;
  animation: overlay-fadeOut ease 0.5s forwards;
}

$wideOffs: 2;
@media (min-aspect-ratio: 9/16) and (max-width: 768px) {
  .logo {
    width: 10vh - $wideOffs;
    width: 10dvh - $wideOffs;
  }
  h1 {
    width: 45vh - $wideOffs;
    width: 45dvh - $wideOffs;
  }
  p {
    width: 45vh - $wideOffs;
    width: 45dvh - $wideOffs;
  }
  ul {
    width: 45vh - $wideOffs;
    width: 45dvh - $wideOffs;
  }
}
</style>
